(function() {
    'use strict';

    angular
        .module('TR')
        .controller('SelectedHotel', SelectedHotel);

        function SelectedHotel(hotelFromSession, arrayUtil, imageService, $q, tripService, $routeParams, basketStore, $route, basketService, flightSearch, occupancyService, taxationService, mandatoryTransferService) {
        const sh = this;
        const w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
        const h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
        sh.getTotalPrice = getTotalPrice;
        sh.nonInfants = occupancyService.getNumberOfNonInfantPassengers();
        sh.totalPrice = '';
        sh.bookingMiles = 0;
        sh.personMiles = personMiles;
        sh.flightMiles = flightMiles;
        sh.changeWorkflowState = changeWorkflowState;
        sh.openImageGallery = openImageGallery;
        sh.hotelImageIndex = 0;
        sh.showHotelImages = false;
        sh.isPackagePrice = TRPCONFIG.Domain.PackagePrice && $route.current && $route.current.area === 'holidays';
        sh.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
        tripService.usePackageRates().then(packagePrice => sh.isPackagePrice = packagePrice);

        sh.showCancellationsPopUp = false;
        sh.findCancellationData = function() {
            let intvl = setInterval(function() {
                if (TRPCONFIG.Domain.BrandedFareCancellations || sessionStorage.getItem('BrandedFareCancellations') !== null) {
                    clearInterval(intvl);
                    sh.showCancellationsPopUp = true;
                }
            }, 200);
        };

        sh.getFlightInfo = function() {
            return flightSearch.getFlightInfo();
        };

        sh.showFlightDetails = function() {
            return flightSearch.showFlightDetailsModal(sh.isHotelFirstJourney);
        };

        sh.showCancellationsDetails = function() {
            return flightSearch.showCancellationsDetailsModal();
        };

        sh.getRoomOccupancyDetails = function() {
            return occupancyService.getRoomOccupancyString().replace('(', 'for ').replace(')', '');
        };

        let isSkywards = document.querySelector('body').getAttribute('data-skywards');
        function changeWorkflowState(breadcrumb) {
            basketService.changeJourneyUrl(breadcrumb);
        }

        function openImageGallery() {
            sh.showHotelImages = true;
        }

        function getTotalPrice(price) {
            sh.totalPrice = Number(price);
        }

        function personMiles() {
            let skywardsMiles = sessionStorage.getItem('SkywardsMiles');
            let miles = 0;
            if (TRPCONFIG.Domain.SkywardsInfo && TRPCONFIG.Domain.SkywardsInfo[0] && TRPCONFIG.Domain.SkywardsInfo[0].Miles) {
                miles = TRPCONFIG.Domain.SkywardsInfo[0].Miles;
                sessionStorage.setItem('SkywardsMiles', miles);
            } else if (TRPCONFIG.Domain.FlightMiles && TRPCONFIG.Domain.FlightMiles[0]) {
                miles = TRPCONFIG.Domain.FlightMiles[0];
            } else {
                miles = skywardsMiles;
            }
            return miles;
        }

        function flightMiles() {
            return sessionStorage.getItem('SkywardsMilesFlights');
        }

        tripService.getTrip($routeParams.tripId).then(function(trip) {
            if (trip && trip.BasketId) {
                taxationService.getCityTax(trip.TripId, trip.BasketId).then(tax => {
                    sh.tax = tax;
                });
                $q.all([basketStore.hotel(trip.BasketId),
                        basketStore.hotelCost(trip.BasketId),
                        basketStore.hotelDeposit(trip.BasketId, $routeParams.productId)]).then(function(results) {
                    const hotelFromBasket = results[0];
                    if (hotelFromBasket) {
                        sh.hotelCost = results[1];
                        sh.hotelDeposit = results[2];
                        sh.hotelImages = arrayUtil.map(arrayUtil.numberArray(0, hotelFromBasket.Details.NumberOfPhotos - 1), function(i) {
                            return {
                                src: imageService.getImageUrl(hotelFromBasket.Details.Id, w, h, i, false)
                            };
                        });
                        sh.mandatoryTransfersCost = mandatoryTransferService.getBookedTransfersPrice(hotelFromBasket.CostBreakdown);
                        hotelFromSession.getHotel(trip.HotelsRequest.AvailabilitySearchId, hotelFromBasket.Details.Id, $routeParams.tripId).then(function(hotel) {
                            sh.hotel = angular.extend(hotel, hotelFromBasket);
                            if (sh.hotel.Details.BookedItems) {
                                for (let i = 0; i < sh.hotel.Details.BookedItems.length; i++) {
                                    let title = sh.hotel.Details.BookedItems[i].Title;
                                    title = title.includes('(') && title.includes(')') ? title.slice(title.lastIndexOf('('), title.lastIndexOf(')') + 1) : null;
                                    let roomType = sh.hotel.Details.BookedItems[i].RoomDescription;
                                    roomType = roomType.replace(/\w+/g, function(w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
                                    let boardType = sh.hotel.Details.BookedItems[i].BoardDescription;
                                    sh.hotel.Details.BookedItems[i].Summary = `${roomType}, ${boardType} ${title}`;
                                }
                                sh.roomCount = sh.hotel.Details.BookedItems.length;
                                if (sh.roomCount > 1) {
                                    sh.roomAndBoardsData = [];
                                    for (let i = 0; i < sh.roomCount; i++) {
                                        sh.roomAndBoardsData.push(`${sh.hotel.Details.BookedItems[i].Summary}`);
                                    }
                                } else {
                                    let title = sh.hotel.Details.BookedItems[0].Title;
                                    title = title.includes('(') && title.includes(')') ? title.slice(title.lastIndexOf('('), title.lastIndexOf(')') + 1) : null;
                                    sh.occupancy = title.replace('(', '').replace(')', '');
                                    sh.adultCount = sh.hotel.Details.BookedItems[0].Adults;
                                    sh.childrenCount = sh.hotel.Details.BookedItems[0].ChildAges.length;
                                }
                            }
                            if (isSkywards) {
                                let tPrice = TRPCONFIG.Domain.TransferPrice;
                                if (tPrice === undefined) {
                                    tPrice = 0;
                                }
                            }
                        });
                    }
                });
            }
        });
    }
})();
